(function () {
  'use strict';

  function normalize(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase('az');
  }

  function hide(element) {
    if (!element) return;
    element.hidden = true;
    element.setAttribute('aria-hidden', 'true');
    element.style.setProperty('display', 'none', 'important');
  }

  function cleanCatalogUi(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(
      '.price,.price__container,.price-item,.asm-product__price,.asm-card-price,' +
      '.product__tax,.product__taxes,.unit-price,' +
      '.volume-pricing,.volume-pricing-note,.totals,.tax-note,.cart-item__price-wrapper,' +
      '.cart-item__totals,.cart__ctas,.cart__checkout-button,[name="checkout"],' +
      '.shopify-payment-button,.shopify-payment-terms,.footer__payment,.list-payment,' +
      '.asm-cart-popup__checkout,.asm-benefits,.asm-b2b-banner,.asm-desktop-trust,' +
      'a[href*="/pages/contact"],a[href*="/checkout"]'
    ).forEach(hide);

    scope.querySelectorAll('h1,h2,h3,h4,strong,b,span,p,a').forEach(function (element) {
      var text = normalize(element.textContent);

      if (text === 'satış nöqtələri' || text === 'satış nöqtələrimiz') {
        hide(element.closest('.asm-desktop-panel, .asm-approved-footer__inner > div, section, div'));
      }

      if (text === 'whatsapp əlaqəsi' || text === 'whatsapp əlaqə' || text === 'əlaqə') {
        var contactBlock = element.closest('.asm-desktop-contact, a');
        if (contactBlock) hide(contactBlock);
      }
    });
  }

  function start() {
    cleanCatalogUi(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) cleanCatalogUi(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
